/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

export default class CasesSlider{
    
    init (){
        
        if($('.js-cases-slider').length){
            
            var swiper = new Swiper(".js-cases-slider", {
                spaceBetween: 50,
                slidesPerView: "auto",
                centeredSlides: true, 
                lazy: {
                    loadedClass: 'loaded',
                    checkInView: true,
                },
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                pagination: {
                    el: ".js-cases-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.js-cases-next',
                    prevEl: '.js-cases-prev'
                }
            });
            
        }
    }
}
